export default {
    config: {
        defaultWidth: 240
    },
    default: {
        label: 'Wishlist Comment'
    },
    unique: [],
    lang: {
        name: 'Wishlist Comment',
        category: ['User', 'Collection'],
        description: 'Comment text on a wishlist item.',
        views: ['list', 'sheet'],
    },
    filters: ['wishlist.comment']
}
